import FormLabelGroup, {
  FormLabelGroupProps,
} from '@appfolio/react-gears/lib/components/FormLabelGroup';
import classNames from 'classnames';
import React from 'react';
import NumberInput, { NumberInputProps } from '../inputs/NumberInput';

export type MultiplierFieldProps = FormLabelGroupProps & NumberInputProps;

export default function NumberField({
  label,
  required,
  hint,
  rowClassName,
  validate,
  initialValue,
  feedback,
  tableField,
  ...props
}: MultiplierFieldProps) {
  return (
    <FormLabelGroup
      stacked
      label={label}
      required={required}
      hint={hint}
      inputId={props.id}
      rowClassName={classNames(rowClassName, { 'no-gutters mb-0': tableField })}
      feedback={feedback}
    >
      <NumberInput {...props} />
    </FormLabelGroup>
  );
}
